export { PageNotFound as default } from './PageNotFound'
